<c-game-base-page [mode]="'new'" />
